<template>
    <div>
        <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Learner Remark Import</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar> -->
        <br>
        <v-row justify="center" align="center">
            <v-col cols="12" sm="4" md="4">
                <v-btn @click="downloadTemplate" color="success" :loading="excelloading" elevation="2" rounded>
                    <v-icon left>mdi-download</v-icon>
                    Download Excel Template
                </v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="4">
                <v-file-input placeholder="CSV of learner subject remark data" prepend-icon="mdi-file"
                    label="Learner Subject Remark" show-size hide-details outlined rounded dense
                    v-model="file"></v-file-input>
            </v-col>
        </v-row>
        <br />
        <v-row justify="center" align="center">
            <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
        </v-row>
        <v-divider class="mt-4"></v-divider>
        <v-expand-transition>
            <div v-if="statuslist.length" class="result-area pa-6 grey lighten-5">
                <div class="d-flex align-center mb-4">
                    <div class="text-h6 font-weight-bold grey--text text--darken-3">Import Summary</div>
                    <v-spacer></v-spacer>
                    <v-chip outlined small color="grey darken-1">Generated at {{ new Date().toLocaleTimeString()
                        }}</v-chip>
                </div>

                <v-row dense>
                    <v-col cols="12" md="4">
                        <v-card flat class="stat-card total-border">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-1">Total Processed</div>
                                    <v-list-item-title class="text-h4 font-weight-black">{{ statuslist.length
                                        }}</v-list-item-title>
                                </v-list-item-content>
                                <v-avatar color="blue lighten-5" size="48">
                                    <v-icon color="blue">mdi-file-document-multiple-outline</v-icon>
                                </v-avatar>
                            </v-list-item>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-card flat class="stat-card success-border">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-1">Successful Imports</div>
                                    <v-list-item-title class="text-h4 font-weight-black green--text text--darken-2">
                                        {{ successCount }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-avatar color="green lighten-5" size="48">
                                    <v-icon color="green">mdi-check-circle-outline</v-icon>
                                </v-avatar>
                            </v-list-item>
                        </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-card flat class="stat-card fail-border">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <div class="text-overline mb-1">Failed Records</div>
                                    <v-list-item-title class="text-h4 font-weight-black red--text text--darken-2">
                                        {{ failCount }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-avatar color="red lighten-5" size="48">
                                    <v-icon color="red">mdi-alert-circle-outline</v-icon>
                                </v-avatar>
                            </v-list-item>
                        </v-card>
                    </v-col>
                </v-row>

                <v-card flat class="mt-6 border-standard overflow-hidden">
                    <v-data-table :headers="resultHeader" :items="statuslist" :items-per-page="10" class="modern-table"
                        fixed-header>
                        <template v-slot:item.Status="{ item }">
                            <v-chip small label depressed
                                :color="item.Status === 'Success' ? 'green lighten-5 green--text text--darken-3' : 'red lighten-5 red--text text--darken-3'"
                                class="font-weight-bold">
                                <v-icon left x-small>{{ item.Status === 'Success' ? 'mdi-check' : 'mdi-close'
                                    }}</v-icon>
                                {{ item.Status }}
                            </v-chip>
                        </template>

                        <template v-slot:item.Reason="{ item }">
                            <span class="grey--text text--darken-2">{{ item.Reason || '—' }}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </v-expand-transition>
        <!-- </v-card> -->

        <v-card class="box">
            <h3 class="section-title mb-3">Reference Data</h3>
            <v-row>
                <v-col cols="12" md="6">
                    <v-simple-table dense class="bordered-table">
                        <thead>
                            <tr>
                                <th style="width:70px">S.No</th>
                                <th>Course Codes</th>
                                <th>Course Name</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in course_list" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.course_code }}</td>
                                <td>{{ item.name }}</td>
                            </tr>

                            <tr v-if="!sem_list.length">
                                <td colspan="5" class="text-center text-grey">
                                    No Data found
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>

                <v-col cols="12" md="3">
                    <v-simple-table dense class="bordered-table">
                        <thead>
                            <tr>
                                <th style="width:70px">S.No</th>
                                <th>Academic Year</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in ay_list" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.ay }}</td>
                            </tr>

                            <tr v-if="!ay_list.length">
                                <td colspan="2" class="text-center text-grey">
                                    No Data found
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>

                <v-col cols="12" md="3">
                    <v-simple-table dense class="bordered-table">
                        <thead>
                            <tr>
                                <th style="width:70px">S.No</th>
                                <th>Semester</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in sem_list" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.sem }}</td>
                            </tr>

                            <tr v-if="!sem_list.length">
                                <td colspan="5" class="text-center text-grey">
                                    No Data found
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import * as XLSX from 'xlsx';
export default {
    components: {
        Breadcrumbs,
    },

    /*
        Defines the data used by the component
      */
    data() {
        return {
            isallowed: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            file: null,
            load: false,
            loading3: false,
            search: "",
            ay_list: null,
            sem_list: null,
            course_list: null,
            output_load: false,
            statuslist: [],
            resultHeader: [
                { text: 'Row No.', value: 'Sr', width: '80px' },
                { text: 'Student PRN', value: 'PRN', width: '150px' },
                { text: 'Subject Code', value: 'Course', width: '150px' },
                { text: 'Status', value: 'Status', width: '130px' },
                { text: 'Reason', value: 'Reason' }
            ],
        };
    },
    mounted() {
        axios
            .post("/dataMigration/getMasterDataForSubjectWiseRemark")
            .then((res) => {
                this.ay_list = res.data.ay_list;
                this.sem_list = res.data.sem_list;
                this.course_list = res.data.course_list;
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            })
            .finally(() => { });
    },
    methods: {
        downloadTemplate() {
            // Create header row
            let header = ["Student PRN", "Student Name", "Academic Year", "Semester", "Course Code", "Remark"];

            const data = [header];

            // Create worksheet
            const ws = XLSX.utils.aoa_to_sheet(data);

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Remark");

            // Download file
            XLSX.writeFile(wb, `Import_Learner_Subject_Remark.xlsx`);
        },

        submitFile() {
            if (this.file == null) {
                alert("Please select the file!");
            } else {
                this.output_load = true;
                this.statuslist = [];
                let formData = new FormData();
                formData.append("file", this.file);

                axios
                    .post("dataMigration/importSubjectWiseRemark", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.statuslist) {
                            this.statuslist = res.data.statuslist;
                            this.load = true;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                            this.overlay = false;
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },

    computed: {
        successCount() {
            return this.statuslist.filter(i => i.Status == "Success").length
        },
        failCount() {
            return this.statuslist.filter(i => i.Status == "Failed").length
        }
    }
};
</script>
<style scoped>
/* new css */
table,
th {
    padding: 10px;
    border: 1px solid black;
    border-collapse: collapse;
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.result-area {
    border-top: 1px solid #e0e0e0;
}

/* Stat Cards */
.stat-card {
    border: 1px solid #e0e0e0 !important;
    transition: all 0.3s ease;
    border-radius: 12px !important;
}

.stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05) !important;
}

.total-border {
    border-left: 6px solid #2196F3 !important;
}

.success-border {
    border-left: 6px solid #4CAF50 !important;
}

.fail-border {
    border-left: 6px solid #F44336 !important;
}

/* Table Styling */
.border-standard {
    border: 1px solid #e0e0e0 !important;
    border-radius: 12px !important;
}

.modern-table>>>thead th {
    background-color: #ffffff !important;
    height: 56px !important;
    color: #757575 !important;
    font-size: 0.8rem !important;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    border-bottom: 2px solid #f5f5f5 !important;
}

.modern-table>>>tbody tr:hover {
    background-color: #fcfdfe !important;
}

.modern-table>>>tbody td {
    height: 60px !important;
    border-bottom: 1px solid #f0f0f0 !important;
}

.result-area {
    border-top: 1px solid #e0e0e0;
}

.bordered-table table {
    border-collapse: collapse;
    width: 100%;
}

.bordered-table th,
.bordered-table td {
    border: 1px solid #ccc;
    padding: 6px;
}

.bordered-table thead th {
    border-bottom: 2px solid #999;
}
</style>
